export default {
  namespaced: true,
  state: {
    api: {},
    item: {},
    newField: false,
    trash: 0,
  },
  mutations: {
    SET_ITEM(state, data) {
      state[data[0]] = data[1];
    },
  },
};
